import { api } from "../api";

export const esgMessage = async (data: any) => {
  const { data: response } = await api.forms.esg(data);

  if (response.errors || !response.success) {
    throw { errors: response.errors };
  }

  return {
    data: response
  };
};
